export const AdminFooter = () => {
  return (
    <footer className="bg-gray-800 text-white p-4 mt-auto">
      <p>© 2024 Admin Dashboard</p>
    </footer>
  );
};